import api from '../api/articles'

const state = {
    articles: false,
}

const getters = {
    getArticles: state => {
        return state.articles
    }
}

const actions = {
    getArticles({ dispatch, commit }, author) {
        return new Promise((resolve, reject) => {
            api.getArticles(author)
                .then((success) => {
                    commit('setArticles', success.items)
                    return resolve(success)
                }).catch((failed) => {
                    commit('setArticles', false)
                    return reject(failed)
                })
        })
    }
}

const mutations = {
    setArticles(state, value) {

        let items = []
        value.forEach(function (article) {
            if (article.fields.categories[0].sys.id == '6VfUVmJj08UerquAWEvr3j') {
                items.push(article)
            }
        });
        state.articles = items
    },
}
export default {
    state, getters, actions, mutations
}
